module.exports = __webpack_public_path__ + "static/media/1.bb2922b1.jpg";